import { WindowWidthState, RootState } from '@/store/types';
import { Module } from 'vuex';

export default {
  namespaced: true,
  state: {
    windowWidth: 0
  },
  getters: {
    getWindowWidth(state: WindowWidthState) {
      return () => {
        return state.windowWidth;
      };
    }
  },
  mutations: {
    setWindowWidth(state, width) {
      state.windowWidth = width;
    }
  }
} as Module<WindowWidthState, RootState>;
